interface BarProps {
  value: number
  max?: number
  color?: string
  height?: number
  label?: string
}

export function Bar({
  value,
  max = 100,
  color = 'var(--steel-blue)',
  height = 6,
  label,
}: BarProps): JSX.Element {
  const ratio = max <= 0 ? 0 : Math.min(1, Math.max(0, value / max))
  return (
    <div
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={max}
      aria-label={label ?? 'progress'}
      style={{
        width: '100%',
        height,
        background: 'var(--surface-2)',
        borderRadius: 999,
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          width: `${ratio * 100}%`,
          height: '100%',
          background: color,
          transition: 'width var(--motion-duration-slow) var(--motion-ease-out)',
        }}
      />
    </div>
  )
}
